import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React from 'react'
import BreakPoints from '../../../styles/breakPoints'
import useRouteParam from '../../../hooks/useRouteParam'

const Wrapper = styled.nav`
  display: none;

  ${BreakPoints.large} {
    display: block;

    .p-nav-area {
      display: flex;
      align-items: center;
      padding: 5px 0 0;
      position: fixed;
      right: 10px;
      z-index: 9998;

      .nav-input {
        display: none;
      }
    }

    .p-nav-area {
      #nav-content {
        display: contents;
        position: relative;
        padding: 50px 0 20px;
      }

      #nav-open {
        width: 34px;
        height: 34px;
        vertical-align: middle;
        cursor: pointer;

        display: flex;
        justify-content: center;
        padding-top: 7px;
      }

      #nav-open span,
      #nav-open span:before,
      #nav-open span:after {
        position: absolute;
        height: 3px; /*線の太さ*/
        width: 25px; /*長さ*/
        border-radius: 3px;
        background: #3ec7b3;
        display: block;
        content: '';
        z-index: 10000;
        transition: 0.1s;
      }

      #nav-open span:before {
        bottom: -8px;
        transition: 0.3s ease-in-out;
      }

      #nav-open span:after {
        bottom: -16px;
        transition: 0.3s ease-in-out;
      }

      /*閉じる用の薄黒箇所*/

      #nav-close {
        display: none;
        position: fixed;
        z-index: 99;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: black;
        opacity: 0;
        transition: 0.3s ease-in-out;
      }

      /*メニューの中身*/

      #nav-content {
        display: block;
        overflow: auto;
        position: fixed;
        top: 0;
        right: -100%;
        z-index: 9999;
        width: 90%;
        max-width: 330px;
        height: 100%;
        background: #fff;
        transition: 0.3s ease-in-out;

        a {
          font-size: 20px;
          font-weight: bold;
          display: flex;
          height: 60px;
          align-items: center;
          width: 90%;
          margin: 0 0 0 auto;
          border-bottom: solid 1px #e0e0e0;
          text-decoration: none;

          &:hover {
            text-decoration: none;
          }
        }

        .bottom {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          padding: 20px;

          a {
            height: 50px;
            border: solid 1px #3ec7b3;
            border-radius: 6px;
            width: 100%;
            justify-content: center;

            &:nth-child(2),
            &:nth-child(3) {
              width: calc((100% - 20px) / 2);
              height: 40px;
              font-size: 18px;
            }
          }
        }
      }

      #nav-input:checked {
        + #nav-open {
          border: solid 1px #e0e0e0;
          background: white;
          position: relative;
          z-index: 10000;
          border-radius: 100vh;
        }

        + #nav-open span {
          width: 0;
        }

        + #nav-open span:before {
          width: 25px;
          transform-origin: 50% 50%;
          transform: rotate(45deg) translate(-20%, 325%);
          left: -2px;
          top: 5px;
        }

        + #nav-open span:after {
          width: 25px;
          transform-origin: 50% 50%;
          transform: rotate(-45deg) translate(-20%, 325%);
          top: -2px;
          left: -16px;
        }
      }

      /*チェックがついたら表示させる*/

      #nav-input:checked ~ #nav-close {
        display: block;
        opacity: 0.5;
      }

      #nav-input:checked ~ #nav-content {
        right: 0;
        box-shadow: 6px 0 25px rgba(0, 0, 0, 0.15);
      }
    }
  }
`

/**
 * ヘルプスマホ用サイドメニュー
 * @constructor
 */
const HelpSpNav = (): JSX.Element => (
  <Wrapper className="nav">
    <div className="p-head-inner">
      <nav className="p-nav-area ">
        <input id="nav-input" type="checkbox" className="nav-input" />
        <label id="nav-open" htmlFor="nav-input">
          <span />
        </label>
        <label className="nav-input" id="nav-close" htmlFor="nav-input">
          <span />
        </label>
        <div id="nav-content">
          <Link to={useRouteParam('/help/first/')} className="p-link">
            はじめてガイド
          </Link>
          <Link to={useRouteParam('/help/movie/')} className="p-link">
            動画マニュアル
          </Link>
          <Link to={useRouteParam('/help/guide/')} className="p-link">
            ご利用ガイド
          </Link>
          <Link to={useRouteParam('/help/manage/')} className="p-link">
            管理職機能
          </Link>
          <Link to={useRouteParam('/help/setting/')} className="p-link">
            各種設定
          </Link>
          <Link to={useRouteParam('/help/faq/')} className="p-link">
            よくあるご質問
          </Link>
          <div className="bottom">
            <Link
              to={useRouteParam('https://app.kintaicloud.jp')}
              className="login"
            >
              ログイン
            </Link>
            <Link to={useRouteParam('/')} className="public">
              製品サイト
            </Link>
            <Link to={useRouteParam('/support/')} className="contact">
              お問い合わせ
            </Link>
          </div>
        </div>
      </nav>
    </div>
  </Wrapper>
)

export default HelpSpNav
